import React from "react";

const AppStoreBadgeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="172"
    height="58"
    viewBox="0 0 172 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.714316"
      y="0.714316"
      width="170.007"
      height="55.7166"
      rx="9.28611"
      fill="black"
    />
    <rect
      x="0.714316"
      y="0.714316"
      width="170.007"
      height="55.7166"
      rx="9.28611"
      stroke="#A6A6A6"
      strokeWidth="1.42863"
    />
    <path
      d="M116.47 27.4311V30.7042H114.419V32.8506H116.47V40.1437C116.47 42.6341 117.597 43.6302 120.431 43.6302C120.929 43.6302 121.404 43.5709 121.819 43.4998V41.377C121.463 41.4126 121.238 41.4363 120.846 41.4363C119.577 41.4363 119.02 40.8434 119.02 39.4915V32.8506H121.819V30.7042H119.02V27.4311H116.47Z"
      fill="white"
    />
    <path
      d="M129.039 43.8081C132.81 43.8081 135.122 41.2822 135.122 37.096C135.122 32.9336 132.798 30.3958 129.039 30.3958C125.268 30.3958 122.943 32.9336 122.943 37.096C122.943 41.2822 125.256 43.8081 129.039 43.8081ZM129.039 41.5431C126.821 41.5431 125.576 39.9184 125.576 37.096C125.576 34.2974 126.821 32.6609 129.039 32.6609C131.245 32.6609 132.502 34.2974 132.502 37.096C132.502 39.9066 131.245 41.5431 129.039 41.5431Z"
      fill="white"
    />
    <path
      d="M137.101 43.5591H139.651V35.9339C139.651 34.1195 141.014 32.898 142.947 32.898C143.398 32.898 144.157 32.981 144.37 33.0522V30.5381C144.098 30.467 143.611 30.4314 143.232 30.4314C141.548 30.4314 140.113 31.3564 139.745 32.6253H139.556V30.6449H137.101V43.5591Z"
      fill="white"
    />
    <path
      d="M150.701 32.566C152.587 32.566 153.82 33.8823 153.879 35.9102H147.357C147.499 33.8942 148.815 32.566 150.701 32.566ZM153.867 40.0726C153.393 41.0806 152.338 41.6379 150.796 41.6379C148.756 41.6379 147.44 40.203 147.357 37.938V37.7957H156.476V36.9063C156.476 32.8506 154.306 30.3958 150.713 30.3958C147.072 30.3958 144.76 33.0166 144.76 37.1435C144.76 41.2703 147.025 43.8081 150.725 43.8081C153.678 43.8081 155.741 42.385 156.322 40.0726H153.867Z"
      fill="white"
    />
    <path
      d="M99.7504 38.79C99.947 41.9612 102.59 43.9892 106.523 43.9892C110.726 43.9892 113.357 41.8629 113.357 38.4705C113.357 35.8033 111.857 34.3283 108.219 33.4802L106.265 33.0009C103.954 32.46 103.02 31.7349 103.02 30.4689C103.02 28.871 104.47 27.8262 106.646 27.8262C108.711 27.8262 110.136 28.8464 110.395 30.4812H113.074C112.914 27.4944 110.284 25.3926 106.683 25.3926C102.811 25.3926 100.23 27.4944 100.23 30.6532C100.23 33.259 101.692 34.8077 104.9 35.5574L107.187 36.1106C109.534 36.6637 110.567 37.4749 110.567 38.8269C110.567 40.4002 108.944 41.5433 106.732 41.5433C104.36 41.5433 102.713 40.4739 102.479 38.79H99.7504Z"
      fill="white"
    />
    <path
      d="M73.3388 30.4314C71.5837 30.4314 70.0658 31.309 69.2831 32.7794H69.0933V30.6449H66.6386V47.8519H69.1882V41.6024H69.3898C70.0658 42.9661 71.5244 43.7725 73.3625 43.7725C76.6236 43.7725 78.6989 41.1992 78.6989 37.096C78.6989 32.9929 76.6236 30.4314 73.3388 30.4314ZM72.6154 41.4838C70.4808 41.4838 69.1408 39.7998 69.1408 37.1079C69.1408 34.4041 70.4808 32.7201 72.6272 32.7201C74.7855 32.7201 76.0781 34.3685 76.0781 37.096C76.0781 39.8354 74.7855 41.4838 72.6154 41.4838Z"
      fill="white"
    />
    <path
      d="M87.6205 30.4314C85.8654 30.4314 84.3475 31.309 83.5648 32.7794H83.3751V30.6449H80.9203V47.8519H83.4699V41.6024H83.6715C84.3475 42.9661 85.8061 43.7725 87.6442 43.7725C90.9054 43.7725 92.9807 41.1992 92.9807 37.096C92.9807 32.9929 90.9054 30.4314 87.6205 30.4314ZM86.8971 41.4838C84.7625 41.4838 83.4225 39.7998 83.4225 37.1079C83.4225 34.4041 84.7625 32.7201 86.909 32.7201C89.0673 32.7201 90.3599 34.3685 90.3599 37.096C90.3599 39.8354 89.0673 41.4838 86.8971 41.4838Z"
      fill="white"
    />
    <path
      d="M62.0641 43.5591H64.9894L58.5857 25.8228H55.6235L49.2197 43.5591H52.0467L53.6815 38.8515H60.4416L62.0641 43.5591ZM56.9632 29.0431H57.1722L59.741 36.5407H54.3821L56.9632 29.0431Z"
      fill="white"
    />
    <path
      d="M50.9324 12.4449V21.001H54.0216C56.5712 21.001 58.0476 19.4297 58.0476 16.6963C58.0476 14.0043 56.5594 12.4449 54.0216 12.4449H50.9324ZM52.2606 13.6545H53.8733C55.6462 13.6545 56.6957 14.7811 56.6957 16.7141C56.6957 18.6767 55.664 19.7914 53.8733 19.7914H52.2606V13.6545Z"
      fill="white"
    />
    <path
      d="M50.9324 12.4449V21.001H54.0216C56.5712 21.001 58.0476 19.4297 58.0476 16.6963C58.0476 14.0043 56.5594 12.4449 54.0216 12.4449H50.9324ZM52.2606 13.6545H53.8733C55.6462 13.6545 56.6957 14.7811 56.6957 16.7141C56.6957 18.6767 55.664 19.7914 53.8733 19.7914H52.2606V13.6545Z"
      fill="white"
    />
  </svg>
);

export default AppStoreBadgeIcon;
